import React from 'react'
import { useForm } from "react-hook-form";
import { TextField, Button, Stack ,Checkbox, FormControlLabel} from "@mui/material";

const Arolsen_Archives = () => {
    const { register, handleSubmit, watch, formState: { errors }, handleChange, control } = useForm();

    const onSubmit = (data) => {
        console.log(data);
    }
  return (
    <>
    <div>


        <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete='off' >
            <Stack spacing={2}>
                <h1>Arolsen Archives</h1>

                <TextField name="arolsen_id" label='Arolsen id' {...register("arolsen_id")} />
               
                <TextField name="nationality" label='Nationality' {...register("nationality")} />
               
                <TextField name="label" label='Label' {...register("label")} />
                
                <TextField type='number' name="number_documents" label='Number of Documents' {...register("number_documents",{valueAsNumber:true})} />

                <FormControlLabel control={<Checkbox {...register('mentions_kampnagel')} />} label="Mentions Kampnagel" />

                <TextField name="checked_documents" label='Checked documents' {...register("checked_documents")} />
                


                <Button type='submit' variant="outlined">Submit</Button>

            </Stack>

        </form>


    </div>
</>
  )
}

export default Arolsen_Archives